import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export function ConsentPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);

  const handleContinue = () => {
    if (!accepted) return;
    navigate(`/c/${token}/instructions`, { replace: true });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="max-w-xl">
        <CardHeader>
          <CardTitle>Consentimiento informado</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Esta evaluación forma parte de un proceso de selección. Tus respuestas se utilizarán
            únicamente para generar un perfil de compatibilidad profesional. No se realiza ningún
            diagnóstico ni predicción de conducta futura. Los resultados son de uso exclusivo del
            área de Recursos Humanos.
          </p>
          <p className="text-sm text-muted-foreground">
            Puedes abandonar en cualquier momento. Al continuar, aceptas que tus datos sean
            procesados conforme a la política de privacidad de la empresa.
          </p>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
            />
            <span className="text-sm">He leído y acepto participar en esta evaluación.</span>
          </label>
          <Button onClick={handleContinue} disabled={!accepted}>
            Continuar
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
